export type CalendarLinks = {
    google: string;
    outlook: string;
    office365: string;
    yahoo: string;
};

export type CalendarTargetId = keyof CalendarLinks | "ics";

export type CalendarTarget = {
    id: CalendarTargetId;
    name: string;
    href: string;
};

export function getCalendarTargets(
    links: CalendarLinks | null,
    downloadLink: string,
): CalendarTarget[] {
    const providers: CalendarTarget[] = links
        ? [
              { id: "google", name: "Google Calendar", href: links.google },
              { id: "outlook", name: "Outlook.com", href: links.outlook },
              { id: "office365", name: "Office 365", href: links.office365 },
              { id: "yahoo", name: "Yahoo Calendar", href: links.yahoo },
          ]
        : [];

    return [
        ...providers.filter((target) => isWebUrl(target.href)),
        { id: "ics", name: "iCalendar (.ics)", href: downloadLink },
    ];
}

function isWebUrl(href: string): boolean {
    try {
        return ["http:", "https:"].includes(new URL(href).protocol);
    } catch {
        return false;
    }
}
